'use strict';

import angular from 'angular';

const UserResource = ['$resource', function($resource) {
  return $resource('/api/users/:id/:controller', {
    id: '@id'
  }, {
    changePassword: {
      method: 'PUT',
      url: '/api/users/changepassword'
    },
    requestReset: {
      method: 'POST',
      url: '/api/users/requestreset'
    },
    checkToken: {
      method: 'POST',
      url: '/api/users/checktoken'
    },
    setPassword: {
      method: 'POST',
      url: '/api/users/setpassword'
    },
    getMe: {
      method: 'GET',
      params: { id: 'me' }
    },
    updateMe: {
      method: 'PUT',
      params: { id: 'me' }
    },
    getAuth: {
      method: 'GET',
      params: {
        id: 'myauth'
      }
    }
  });
}];

export default angular.module('georgeApp.userSvc', [])
  .factory('UserSvc', UserResource)
  .name;
